/**
 * @generated SignedSource<<3042ee45cbe52a31cf0e5d2f45317589>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useFDFQuoteVariant_buyer$data = {
  readonly addressBook: {
    readonly addressList: ReadonlyArray<{
      readonly country: string | null;
    } | null> | null;
    readonly personalAddress: {
      readonly country: string | null;
    } | null;
    readonly proAddress: {
      readonly country: string | null;
    } | null;
  } | null;
  readonly " $fragmentType": "useFDFQuoteVariant_buyer";
};
export type useFDFQuoteVariant_buyer$key = {
  readonly " $data"?: useFDFQuoteVariant_buyer$data;
  readonly " $fragmentSpreads": FragmentRefs<"useFDFQuoteVariant_buyer">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "country",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "partialAddressCheckoutEligibility"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "useFDFQuoteVariant_buyer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "partialAddressCheckoutEligibility",
          "variableName": "partialAddressCheckoutEligibility"
        }
      ],
      "concreteType": "AddressBook",
      "kind": "LinkedField",
      "name": "addressBook",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Address",
          "kind": "LinkedField",
          "name": "proAddress",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Address",
          "kind": "LinkedField",
          "name": "personalAddress",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Address",
          "kind": "LinkedField",
          "name": "addressList",
          "plural": true,
          "selections": (v0/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};
})();

(node as any).hash = "8da90c13f71a82ae38fc9193eeff21c7";

export default node;
